// Renders text but shows any "number/number" fraction as a stacked fraction
// with a horizontal bar (e.g. 3/4 becomes 3 over 4) instead of a slash.
// Skips things that look like dates or longer number groups (12/05/2024).
export const MathText = ({ children, className }) => {
  const text = typeof children === "string" ? children : String(children ?? "");
  const parts = [];
  const re = /\d+\/\d+/g;
  let last = 0;
  let key = 0;
  let m;
  while ((m = re.exec(text)) !== null) {
    const start = m.index;
    const end = start + m[0].length;
    const before = start > 0 ? text[start - 1] : "";
    const after = end < text.length ? text[end] : "";
    const isFraction = !/[\d/]/.test(before) && !/[\d/]/.test(after);
    if (!isFraction) continue; // leave inside the surrounding text slice
    if (start > last) parts.push(text.slice(last, start));
    const [num, den] = m[0].split("/");
    parts.push(
      <span key={`f${key++}`} className="inline-flex flex-col items-center leading-none mx-[2px] text-[0.9em]" style={{ verticalAlign: "middle" }}>
        <span className="block px-1 leading-tight">{num}</span>
        <span className="block px-1 leading-tight border-t-2 border-current">{den}</span>
      </span>
    );
    last = end;
  }
  if (last < text.length) parts.push(text.slice(last));
  return <span className={className}>{parts}</span>;
};

export default MathText;
